import { render } from "./MainHeaderComponent.vue?vue&type=template&id=7e05106a&scoped=true"
const script = {}

import "./MainHeaderComponent.vue?vue&type=style&index=0&id=7e05106a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e05106a"]])

export default __exports__